import { IAppointments } from '../../services/events/interface';

export interface IEventState {
  emailsGuest: IAppointments[];
}

export const INITIAL_STATE: IEventState = {
  emailsGuest: []
};
